import createIcon from '../../createIcon';

/**
 * @component @name Gradient
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgOUgxM1YxMUgxMVY5Wk05IDExSDExVjEzSDlWMTFaTTEzIDExSDE1VjEzSDEzVjExWk0xNSA5SDE3VjExSDE1VjlaTTcgOUg5VjExSDdWOVpNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05IDE4SDdWMTZIOVYxOFpNMTMgMThIMTFWMTZIMTNWMThaTTE3IDE4SDE1VjE2SDE3VjE4Wk0xOSAxMUgxN1YxM0gxOVYxNUgxN1YxM0gxNVYxNUgxM1YxM0gxMVYxNUg5VjEzSDdWMTVINVYxM0g3VjExSDVWNUgxOVYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Gradient = createIcon('Gradient', [
  [
    'path',
    {
      d: 'M11 9H13V11H11V9ZM9 11H11V13H9V11ZM13 11H15V13H13V11ZM15 9H17V11H15V9ZM7 9H9V11H7V9ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18ZM19 11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z',
      key: 'l0cfpu',
    },
  ],
]);

export default Gradient;
